export default "__VITE_ASSET__BRmeRgxK__"